module.exports = __webpack_public_path__ + "img/default.bb481655.jpg";